const zoneRootUrl = "site";

const getZoneUrl = siteId => `${zoneRootUrl}/${siteId}/Zone`;

const getZoneList = siteId => `${getZoneUrl(siteId)}/list`;
const getZonePowerUrl = (siteId, zoneId) => `site/${siteId}/zone/${zoneId}/power`;
const getZoneDemandUrl = (siteId, zoneId) => `site/${siteId}/zone/${zoneId}/demand`;
const getZoneDLCUrl = (siteId, zoneId) => `site/${siteId}/Zone/${zoneId}/DLC`;
const getZoneMetersUrl = (siteId, zoneId) => `site/${siteId}/Zone/${zoneId}/meters`;
const getUpdateZoneTypeUrl = (siteId, zoneId) => `${zoneRootUrl}/${siteId}/Zone/${zoneId}/type`;

const getAddZoneDataSourceUrl = (siteId, zoneId) => `${zoneRootUrl}/${siteId}/zone/${zoneId}/datasource/add`;
const getRemoveZoneDataSourceUrl = (siteId, zoneId) => `${zoneRootUrl}/${siteId}/zone/${zoneId}/datasource/remove`;

export default {
  getZoneUrl,
  zoneRootUrl,
  getZoneList,
  getZonePowerUrl,
  getZoneDemandUrl,
  getZoneDLCUrl,
  getZoneMetersUrl,
  getUpdateZoneTypeUrl,
  getAddZoneDataSourceUrl,
  getRemoveZoneDataSourceUrl
};
